<template>
  <div @click="routerLink()"
    class="mdl-shadow--1dp mdl-card_acao"
    :style="segmento"
  >
    <span class="span-minicard-text">{{texto}}</span>&nbsp;
    <ArrowRightCircleOutline :size="40" style="color:white;"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ArrowRightCircleOutline from "vue-material-design-icons/ArrowRightCircleOutline.vue";

export default {
  name: 'MiniCardAcao',
  components: {
    ArrowRightCircleOutline,
  },
  props: ['texto','router'],
  computed: {
  ...mapGetters({
      participante: "participante",
      plano: "plano"
    }),
  },
  data() {
    return {
      segmento: ''
    }
  },
  created() {
    var background = this.participante.segmento
    if (background.seg_acao && background.seg_acao.card && background.seg_acao.card.background)
    this.segmento = background.seg_acao.card.background
  },
  methods: {
    routerLink() {
      this.$root.$router.push(this.router)
    }
  }
}
</script>

